var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-box",class:_vm.direction},[(_vm.visible)?_c('div',{staticClass:"message",style:({'background-color':_vm.color})},[_c('div',{staticClass:"message-content"},[_vm._v(_vm._s(_vm.message))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }